import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=6583191e&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=6583191e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583191e",
  null
  
)

export default component.exports